module.exports = __webpack_public_path__ + "static/media/galeryCoatings1.26a49f9f.jpg";